import $ from "jquery";

const gformSelectActive = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: '.gform_wrapper .gfield--type-select .gfield_select'
        }
        if ($(el.main).length === 0) return

        $(function ($) {
            $(el.main).each(function () {
                const $select = $(this);

                // when on change
                $select.on('change', function () {
                    $select.toggleClass('option-selected');
                });
            });
        });
    };

    init();
};

try {
    gformSelectActive();
} catch (error) {
    console.error('gformSelectActive', error);
}
